import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DeliveryLoadingJobQueue } from "src/components/views/erp/delivery/deliveryLoading/DeliveryLoadingJobQueue.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/erp/sales/delivery/loading")({
	staticData: { title: i18n.t("loading.noun_logistics"), legacyViewKey: "customerOrderDeliveryLoadingPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <DeliveryLoadingJobQueue isActive={isActive} />;
}
